<div class="flex flex-col gap-4">
    <div class="mb-2">
        <app-units-grid-input
            [rows]="getPointsArray()"
            [columns]="columns()"
            [userUnits]="userUnits()"
            [tableTitle]="'UDT Custom Points'"
            [resetConfirmationMessage]="'Reset custom points to Gradient defaults?'"
            [allowDeleteRows]="true"
            [minRows]="1"
            [enableClipboardPaste]="true"
            [enableFileImport]="true"
            [createRow]="createPointRow"
            [beforePasteTransform]="customPointsPasteTransform"
            (cellEdited)="onCellEdited()"
            (pasteApplied)="onCellEdited()"
            (rowDeleted)="removePoint($event)"
            (rowsReset)="requestResetCustomPoints()"
        />
    </div>
</div>
